import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-modal-np-discount-info',
  templateUrl: './modal-np-discount-info.component.html',
  styleUrls: ['./modal-np-discount-info.component.scss']
})
export class ModalNpDiscountInfoComponent {
  @Input() npShippingMarkupPercentage: number;
  @Output() discountAgree: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() discountNotAgree: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() discountNotShow: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;

  show() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }

  notAgree() {
    this.closeModal();
    this.discountNotAgree.emit();
  }

  agree() {
    this.closeModal();
    this.discountAgree.emit();
  }

  doNotShow() {
    this.closeModal();
    this.discountNotShow.emit();
  }

  closeModal() {
    this.isModalShow = false
    this.isDarkBackground = false;
  }
}
